

































































































import { defineComponent, ref, useMeta, Ref, computed } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

import { useUserStore } from '@/store/user'
import { useCMSGlobalSettingsStore } from '@/store/cms'
import { useProductStore } from '~/store/product'
import { usePdpStore } from '~/store/pdp'

import { useCountry } from '~/composables/country/useCountry'
import { useBaseUrl } from '~/composables/useBaseUrl'

import { INTRASEQ_TEMPLATES, PRODUCT_STATUS, PRODUCT_TYPES } from '@/common/utils/product/constants'
import { customWithHttps } from '~/common/utils/urls'
import { protocolsProductTypes } from '@/common/mapping/datasheets'

import IconFaSolidLightbulb from '~icons/fa-solid/lightbulb'
import IconFaSolidBookOpen from '~icons/fa-solid/book-open'
export default defineComponent({
  props: {
    confData: {
      type: Object,
      default: undefined,
    },
  },
  components: {
    IconFaSolidLightbulb,
    IconFaSolidBookOpen,
  },
  setup({ confData }) {
    const { isUS } = useCountry()
    const { currentProduct } = useProductStore()
    const { template } = usePdpStore()
    const { getAttributeByCountry } = useCMSGlobalSettingsStore()
    const { selectedCountry: currentCountryCode } = storeToRefs(useUserStore())
    const baseUrl = useBaseUrl()

    const b2dAllowedAddToBasket = getAttributeByCountry('b2dAllowedCountries')

    const productId = currentProduct.data.key
    const productName = currentProduct.data.name
    const productType = currentProduct.data.productType
    const productStatus = currentProduct.data.attributes.statusDates.status
    const safetyDatasheets = currentProduct.data.attributes.safetyDatasheets
    const coa = currentProduct.data.attributes.certificateOfAnalysis
    const pdfFileName = currentProduct.data.attributes.pdf
    const datasheetLinks: Ref<Array<string>> = ref([])

    const hasSDS = safetyDatasheets?.sds ? safetyDatasheets.sds : false
    const allowedProductTypesForDatasheets: boolean = confData?.allowedProductTypesForDatasheets.includes(productType)
    const isB2dAllowedAddToBasket: boolean = b2dAllowedAddToBasket.value.includes(
      currentCountryCode.value.toLowerCase()
    )

    // change/remove these once we have static pages ready
    const antibodyGuaranteeUrl = '/about-us/our-approach-process/cst-antibody-performance-guarantee'
    const faqUrl = '/learn-and-support/frequently-asked-questions'
    const orderSupportUrl = '/learn-and-support/support-information'
    const localInformationUrl = `/product-information/local-information?productNo=${productId}&productName=${productName}`
    const signalstarMultiplexIhcFaqUrl = '/applications/signalstar-multiplex-ihc-faq'

    const buildDatasheetUrl = (productId: string, includeImage: boolean, includeProtocol: boolean) => {
      const datasheetUrl = `/products/${productId}/datasheet?images=${includeImage ? 1 : 0}&protocol=${
        includeProtocol ? 1 : 0
      }${isUS.value ? '' : '&size=A4'}`
      addDatasheetLink(`?images=${includeImage ? 1 : 0}&protocol=${includeProtocol ? 1 : 0}`)
      return datasheetUrl
    }

    const buildPdfDatasheetUrl = () => {
      const datasheetUrl = `//${confData.mediaUrl}/pdf/${pdfFileName}`
      addDatasheetLink(datasheetUrl)
      return datasheetUrl
    }

    const buildSdsUrl = (nameOfFile: string) => {
      return `//${confData.mediaUrl}/s3sds/${nameOfFile}`
    }

    const buildCoaUrl = () => {
      return `//${confData.mediaUrl}/coa/${coa?.coa['url-key']}/${coa?.coa['pdf-file']}`
    }

    const datasheetSelect = ref('')

    const onDatasheetSelect = (e: any) => {
      window.open(e.target.value, '_blank')
      datasheetSelect.value = ''
    }

    const addDatasheetLink = (datasheetLink: string) => {
      if (!datasheetLinks.value.includes(datasheetLink)) {
        datasheetLinks.value.push(datasheetLink)
      }
    }

    const displayIntraseqLinks = computed(() => {
      return !!template && INTRASEQ_TEMPLATES.includes(template.title)
    })
    const appendDatasheetLink = computed(() => {
      return datasheetLinks.value.map((link) => {
        if (link.includes('.pdf')) {
          return {
            rel: 'alternate',
            href: customWithHttps(link),
            type: 'application/pdf',
            media: 'print',
          }
        } else {
          const sefUrl = currentProduct.data.attributes.sefUrl
          return {
            rel: 'alternate',
            href: `${baseUrl}${sefUrl}/datasheet${link}`,
            type: 'text/html',
            media: 'print',
          }
        }
      })
    })

    useMeta(() => ({
      link: [...appendDatasheetLink.value],
    }))

    return {
      isUS,
      hasSDS,
      productType,
      productId,
      allowedProductTypesForDatasheets,
      safetyDatasheets,
      coa,
      productStatus,
      antibodyGuaranteeUrl,
      faqUrl,
      orderSupportUrl,
      localInformationUrl,
      signalstarMultiplexIhcFaqUrl,
      isB2dAllowedAddToBasket,
      buildDatasheetUrl,
      buildPdfDatasheetUrl,
      buildSdsUrl,
      buildCoaUrl,
      PRODUCT_STATUS,
      onDatasheetSelect,
      datasheetSelect,
      PRODUCT_TYPES,
      displayIntraseqLinks,
      pdfFileName,
      protocolsProductTypes,
    }
  },
  head: {},
})
